/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {useDispatch} from 'react-redux'
import {addLeadAdTypeSuccess} from '../action/actionCreators'
import LeadAdTypeForm from './LeadAdTypeForm'
import API from 'config/API'
import {Notifier} from 'components/Notifier'
import {ModalContext} from 'context/ModalContext'

const AddLeadAdType = () => {
  const [loading, setLoading] = React.useState(false)
  const {hideModal} = React.useContext(ModalContext)
  const dispatch = useDispatch()

  const onSubmit = async (values, setError) => {
    try {
      setLoading(true)
      const response = await API.post(`/crm/lead_ad_types`, {name: values.name})
      setLoading(false)
      dispatch(addLeadAdTypeSuccess(response.data.data))
      hideModal()
      Notifier.successMessage('Lead Ad has been created!')
    } catch (error) {
      for (let err in error.response.data.errors) {
        setError(err, {message: error.response.data.errors[err][0]})
      }
      setLoading(false)
    }
  }

  return <LeadAdTypeForm onSubmitHandler={onSubmit} loading={loading} />
}

export default AddLeadAdType
